import { render, staticRenderFns } from "./AssessmentForm.vue?vue&type=template&id=06e18d0e&scoped=true"
import script from "./AssessmentForm.vue?vue&type=script&lang=js"
export * from "./AssessmentForm.vue?vue&type=script&lang=js"
import style0 from "./AssessmentForm.vue?vue&type=style&index=0&id=06e18d0e&prod&lang=scss"
import style1 from "./AssessmentForm.vue?vue&type=style&index=1&id=06e18d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e18d0e",
  null
  
)

export default component.exports